import { render } from "./jhPageRuleModal.vue?vue&type=template&id=0de37c4d&scoped=true"
import script from "./jhPageRuleModal.vue?vue&type=script&lang=js"
export * from "./jhPageRuleModal.vue?vue&type=script&lang=js"

import "./jhPageRuleModal.vue?vue&type=style&index=0&id=0de37c4d&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de37c4d"]])

export default __exports__